import type {
  WorkspacePostingJobTypeResource,
  WorkspacePostingOpportunityResource,
  WorkspacePostingStatusResource,
} from '@/features/opportunities/api/resources/workspace-posting-opportunity'
import type {
  WorkspacePostingJobType,
  WorkspacePostingOpportunityProps,
  WorkspacePostingStatus,
} from './WorkspacePostingOpportunity'
import { maybeParseDate } from '@/utils/date-util'
import { match } from '@/utils/pattern-match-util'

/**
 * Maps a workspace's posting for outsourcing work.
 */
export function mapWorkspacePostingOpportunityResourceToProps(
  resource: WorkspacePostingOpportunityResource,
): Partial<WorkspacePostingOpportunityProps> {
  return {
    id: resource.id,
    workspaceId: resource.workspace_id,
    dateCreated: maybeParseDate(resource.date_created),
    dateModified: maybeParseDate(resource.date_modified),
    location: resource.location,
    primarySoftware: resource.primary_software,
    supplementalSoftware: resource.supplemental_software,
    backupFileNeeded: resource.backup_file_needed,
    jobTypes: resource.job_types.map(
      mapWorkspacePostingJobTypeResourceToWorkspacePostingJobType,
    ),
    specialties: resource.specialties,
    capacity: resource.capacity,
    description: resource.description,
    maxAllowedWorkspaces: resource.max_allowed_workspaces,
    status: mapWorkspacePostingStatusResourceToWorkspacePostingStatus(
      resource.status,
    ),
    isApplicant: resource.is_applicant,
  }
}

function mapWorkspacePostingStatusResourceToWorkspacePostingStatus(
  status: WorkspacePostingStatusResource,
): WorkspacePostingStatus {
  return match(status, {
    DRAFT: 'Draft',
    ACTIVE: 'Active',
    CLOSED: 'Closed',
    CANCELLED: 'Cancelled',
    IN_REVIEW: 'InReview',
  })
}

function mapWorkspacePostingJobTypeResourceToWorkspacePostingJobType(
  jobType: WorkspacePostingJobTypeResource,
): WorkspacePostingJobType {
  return match(jobType, {
    PREP: 'Prep',
    REVIEW: 'Review',
    BOOKKEEPING: 'Bookkeeping',
  })
}
